import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import type { TimelineOption, TimelinePage } from "@insights/contracts";
import { api } from "../../../api";

export function useTimelineOptions(workspaceId: string | undefined) {
  return useQuery({
    enabled: Boolean(workspaceId),
    queryKey: ["timeline-options", workspaceId],
    queryFn: () =>
      api<TimelineOption[]>(`/${workspaceId}/builds/timeline-options`),
  });
}

export function useEnvironmentTimeline(
  workspaceId: string | undefined,
  option: TimelineOption | undefined,
) {
  return useInfiniteQuery({
    enabled: Boolean(workspaceId && option),
    queryKey: [
      "environment-timeline",
      workspaceId,
      option?.repository,
      option?.profile,
    ],
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam }) => {
      const query = new URLSearchParams({
        repository: option?.repository ?? "",
        profile: option?.profile ?? "",
        limit: "20",
      });
      if (pageParam) {
        query.set("cursor", pageParam);
      }

      return api<TimelinePage>(
        `/${workspaceId}/builds/timeline?${query.toString()}`,
      );
    },
    getNextPageParam: (page) => page.nextCursor ?? undefined,
  });
}
